<mat-expansion-panel
  class="platformcatalog-panel"
  [expanded]="expanded"
  [disabled]="disabled"
  (afterExpand)="onAfterExpand()"
  (afterCollapse)="onAfterCollapse()"
>
  <mat-expansion-panel-header class="platformcatalog-panel__header">
    <div class="header">
      <div class="title-row">
        @if (editMode) {
          <div class="title-name-col" (click)="$event.stopPropagation()">
            <mat-form-field class="catalog-name-form-field" appearance="fill" subscriptSizing="dynamic">
              <mat-label>Katalogbezeichnung</mat-label>
              <mat-icon class="catalog-name-form-field__icon" matPrefix> menu_book </mat-icon>

              <input
                #nameInput
                matInput
                [formControl]="nameControl"
                placeholder="Bezeichnung des Plattformkatalogs"
                (keydown)="$event.stopPropagation()"
              />
            </mat-form-field>
          </div>

          <div class="title-actions-col">
            <button mat-stroked-button class="actions-button" (click)="$event.stopPropagation(); onEditCancel()">
              <mat-icon>close</mat-icon>
            </button>

            <button
              mat-flat-button
              color="accent"
              class="actions-button"
              [disabled]="nameControl.invalid"
              (click)="$event.stopPropagation(); onEditSave()"
            >
              <mat-icon>check</mat-icon>
              <span>Speichern</span>
            </button>
          </div>
        } @else {
          <ng-content select="mat-panel-title" />
          <ng-content select="mat-panel-description" />
        }
      </div>

      <div class="actions-row">
        <nav class="actions-row__tabs no-divider" mat-tab-nav-bar mat-stretch-tabs="false" [tabPanel]="tabPanel">
          <span
            class="actions-row__tab"
            mat-tab-link
            [active]="expanded && activeTab === 'catalogs'"
            (click)="!onTabClick('catalogs') && $event.stopPropagation()"
          >
            {{ countInfo.industryCatalogs | number }}
            {{ countInfo.industryCatalogs === 1 ? ' Katalog' : ' Kataloge' }}
          </span>
          <span
            class="actions-row__tab"
            mat-tab-link
            [active]="expanded && activeTab === 'organizations'"
            (click)="!onTabClick('organizations') && $event.stopPropagation()"
          >
            {{ countInfo.organizations | number }}
            {{ countInfo.organizations === 1 ? ' Organisation' : ' Organisationen' }}
          </span>
          <span class="actions-row__tab" mat-tab-link disabled> {{ countInfo.articles | number }} Artikel </span>
        </nav>

        <div class="actions-row__actions" (click)="$event.stopPropagation()">
          <ng-content select="[platformcatalog-panel-action-button]" />
        </div>
      </div>
    </div>
  </mat-expansion-panel-header>

  <!-- Content -->
  <mat-tab-nav-panel #tabPanel>
    @if (expanded) {
      <div class="tab-row">
        <ng-content />
      </div>
    }
  </mat-tab-nav-panel>
</mat-expansion-panel>
